module.exports = __webpack_public_path__ + "img/0-104.7206befb.jpg";